var map = {
	"./Auth/Login": 9011,
	"./Auth/Login.vue": 9011,
	"./BatchSales/Create": 9071,
	"./BatchSales/Create.vue": 9071,
	"./BatchSales/Edit": 8479,
	"./BatchSales/Edit.vue": 8479,
	"./BatchSales/Index": 9912,
	"./BatchSales/Index.vue": 9912,
	"./Batches/Create": 9661,
	"./Batches/Create.vue": 9661,
	"./Batches/Edit": 2930,
	"./Batches/Edit.vue": 2930,
	"./Batches/Index": 1644,
	"./Batches/Index.vue": 1644,
	"./Cart/Index": 6777,
	"./Cart/Index.vue": 6777,
	"./Contacts/Create": 9363,
	"./Contacts/Create.vue": 9363,
	"./Contacts/Edit": 7733,
	"./Contacts/Edit.vue": 7733,
	"./Contacts/Index": 2834,
	"./Contacts/Index.vue": 2834,
	"./Customers/Create": 2607,
	"./Customers/Create.vue": 2607,
	"./Customers/Edit": 6563,
	"./Customers/Edit.vue": 6563,
	"./Customers/Index": 7093,
	"./Customers/Index.vue": 7093,
	"./Dashboard/Index": 6118,
	"./Dashboard/Index.vue": 6118,
	"./Discharges/Create": 5594,
	"./Discharges/Create.vue": 5594,
	"./Discharges/Edit": 5093,
	"./Discharges/Edit.vue": 5093,
	"./Discharges/Index": 8445,
	"./Discharges/Index.vue": 8445,
	"./DiscountedLoadingProducts/Create": 4832,
	"./DiscountedLoadingProducts/Create.vue": 4832,
	"./Home/Coupon": 2415,
	"./Home/Coupon.vue": 2415,
	"./Home/DeleteUser": 8626,
	"./Home/DeleteUser.vue": 8626,
	"./Home/Index": 7307,
	"./Home/Index.vue": 7307,
	"./Home/Participate": 3225,
	"./Home/Participate.vue": 3225,
	"./Home/Privacy-policy": 1304,
	"./Home/Privacy-policy.vue": 1304,
	"./Home/Social": 5899,
	"./Home/Social.vue": 5899,
	"./Home/Stores": 8849,
	"./Home/Stores.vue": 8849,
	"./Home/TerminiCondizioni": 1163,
	"./Home/TerminiCondizioni.vue": 1163,
	"./LoadingProducts/Create": 6222,
	"./LoadingProducts/Create.vue": 6222,
	"./Organizations/Create": 2120,
	"./Organizations/Create.vue": 2120,
	"./Organizations/Edit": 7794,
	"./Organizations/Edit.vue": 7794,
	"./Organizations/Index": 1808,
	"./Organizations/Index.vue": 1808,
	"./Products/Create": 5191,
	"./Products/Create.vue": 5191,
	"./Products/Edit": 9418,
	"./Products/Edit.vue": 9418,
	"./Products/EditPrice": 1308,
	"./Products/EditPrice.vue": 1308,
	"./Products/Import": 5720,
	"./Products/Import.vue": 5720,
	"./Products/Index": 3807,
	"./Products/Index.vue": 3807,
	"./Products/SearchProduct": 1369,
	"./Products/SearchProduct.vue": 1369,
	"./Reports/Index": 3223,
	"./Reports/Index.vue": 3223,
	"./Sales/Create": 3938,
	"./Sales/Create.vue": 3938,
	"./Sales/Edit": 1743,
	"./Sales/Edit.vue": 1743,
	"./Sales/Index": 9503,
	"./Sales/Index.vue": 9503,
	"./Users/Create": 3704,
	"./Users/Create.vue": 3704,
	"./Users/Edit": 6046,
	"./Users/Edit.vue": 6046,
	"./Users/Index": 2466,
	"./Users/Index.vue": 2466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;